import { Link, Typography } from '@mui/material';
import { ToastContentProps } from 'react-toastify';

import { openDownloadsPanel } from '../../utils/downloadsPanel';

/**
 * Success toast for download jobs, taking the react-toastify toast props
 * (including `closeToast`) so it can be passed as toast content.
 */
const DownloadReadyToast = ({
  closeToast,
}: Partial<ToastContentProps<unknown>>) => (
  <Typography variant='body2'>
    Your meter readings download has started.{' '}
    <Link
      component='button'
      type='button'
      color='inherit'
      sx={{ fontWeight: 'bold', verticalAlign: 'baseline' }}
      onClick={() => {
        closeToast?.();
        openDownloadsPanel();
      }}
    >
      View downloads
    </Link>
  </Typography>
);

export default DownloadReadyToast;
